import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { getPreviousLocation } from 'js/store/app/App.selectors';
import { trackPrevPage } from 'js/store/app/App.actions';

export function useRouteInfo(isRouter) {
  const dispatch = useDispatch();
  const previousLocationFromStore = useSelector(getPreviousLocation);

  const location = useLocation();
  const params = useParams();

  const prevLocationRef = React.useRef(location);

  React.useEffect(() => {
    if (!isRouter) return;

    if (prevLocationRef.current.pathname !== location.pathname) {
      dispatch(trackPrevPage(prevLocationRef.current));
      prevLocationRef.current = location;
    }
  }, [location.pathname]);

  return {
    location,
    pathname: location.pathname,
    state: location.state ?? {},
    params,
    previousLocation: previousLocationFromStore,
  };
}
